module.exports = __webpack_public_path__ + "static/media/lightning.6b787586.jpg";